import {
  IInvoiceDonationLoveCodeOption,
  IInvoiceCarrierTypeOption,
} from '../domain/entities/Config';
import InvoiceDetails from '../domain/entities/InvoiceDetails';
import { IInvoiceDisplayData } from '../interfaces/ViewModels';
import { INVOICE_DONATE_MARKS, FIELD_TYPE } from '../constants/Constants';
export interface IInvoicSelectOptions {
  invoiceCarrierTypeOptions: IInvoiceCarrierTypeOption[];
  invoiceDonationLoveCodeOptions: IInvoiceDonationLoveCodeOption[];
}

const getInvoiceDisplayData = (
  selectOptions: IInvoicSelectOptions,
  invoiceDetails?: InvoiceDetails,
): IInvoiceDisplayData | undefined => {
  if (
    !invoiceDetails ||
    invoiceDetails.toJSON()[FIELD_TYPE.INVOICE_DONATE_MARK] ===
      INVOICE_DONATE_MARKS.NONE
  ) {
    return undefined;
  }

  const { invoiceCarrierTypeOptions, invoiceDonationLoveCodeOptions } =
    selectOptions;

  const {
    [FIELD_TYPE.CORPORATE_NAME]: corporateName,
    [FIELD_TYPE.CORPORATE_TAX_ID]: corporateTaxId,
    [FIELD_TYPE.INVOICE_CARRIER_ID]: carrierId,
    [FIELD_TYPE.INVOICE_CARRIER_TYPE]: carrierType,
    [FIELD_TYPE.INVOICE_DONATE_MARK]: invoiceType,
    [FIELD_TYPE.INVOICE_DONATION_LOVE_CODE]: donationLoveCode,
  } = invoiceDetails.toJSON();

  return {
    carrierId,
    carrierType,
    carrierTypeLabel:
      invoiceCarrierTypeOptions.find(option => option.value === carrierType)
        ?.label || '',
    corporateName,
    corporateTaxId: corporateTaxId || '',
    donationReceiptOrganization:
      invoiceDonationLoveCodeOptions.find(
        option => option.value === donationLoveCode,
      )?.label || '',
    invoiceType,
  };
};

export { getInvoiceDisplayData };
